<div class="discoveryProcessContainer">
    <div *ngIf="isDiscoveryAlreadyDone" class="discoveryChat_doneContainer">
        <mat-icon class="discoveryChat_doneIcon">check_circle</mat-icon>
        <span class="discoveryChat_doneText">{{ 'discoveryProcess.discoveryCompleted' | translate }}</span>
    </div>
    <app-progress-bar
        *ngIf="!isDiscoveryAlreadyDone"
        class="discoveryProcess_progessBar"
        [value]="progressBarValue"
    ></app-progress-bar>
    <div class="discoveryChat_container" *ngIf="!isDiscoveryAlreadyDone">
        <div class="discoveryChat_header"></div>
        <div class="discoveryChat_body" #chatBody>
            <app-chat-roll [chatMsgs]="answeredQuestionList" (selectDifferentAnswerEvent)="selectDiffernetAnswer()"></app-chat-roll>
            <app-chat-current-question
                [focusBottom]="focusBottom"
                [isLoading]="isLoading"
                [currentQuestion]="questionList ? questionList[currentQuestionPos]: undefined"
                [consultant]="consultant"
                [removeResponses]="prevQuestionSetResponseToRemove"
                (sendQuestionResponseEvent)="setQuestionResponse($event)">
            </app-chat-current-question>
        </div>
    </div>
</div>
